module.exports = __webpack_public_path__ + "img/huawei.55af5b56.png";